import {
  requiredValidator,
  isCpfValidValidator,
  isEmailValidValidator,
  minLengthValidator, maxLengthValidator
} from 'modules/Forms/helpers/fieldValidation';
import { FIELDS_RENDER_METHOD } from 'modules/Forms/constants/FieldsRenderMethod.constants';

export const EXISTING_CUSTOMER_ID_FORM_FIELDS = {
  ID: 'customerId',
  NAME: 'customerName',
  ORDER_NUMBER: 'orderNumber',
  EMAIL: 'customerEmail',
}

export const EXISTING_CUSTOMER_SUBSECTION = {
  title: 'Identificação',
  fields: [
    {
      id: EXISTING_CUSTOMER_ID_FORM_FIELDS.ID,
      mask: '999.999.999-99',
      validators: [requiredValidator, isCpfValidValidator],
      type: 'text',
      placeholder: 'CPF *',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_WIDTH_COMPACT,
      maxLength: 14,
      isRequired: true,
    },
    {
      id: EXISTING_CUSTOMER_ID_FORM_FIELDS.NAME,
      validators: [requiredValidator, minLengthValidator(3), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'Nome *',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_WIDTH_WIDE,
      isRequired: true,
    },
    {
      id: EXISTING_CUSTOMER_ID_FORM_FIELDS.ORDER_NUMBER,
      validators: [requiredValidator, minLengthValidator(10), maxLengthValidator(12)],
      type: 'text',
      placeholder: 'Número do pedido *',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_EQUAL,
      isRequired: true,
    },
    {
      id: EXISTING_CUSTOMER_ID_FORM_FIELDS.EMAIL,
      validators: [requiredValidator, isEmailValidValidator, minLengthValidator(3), maxLengthValidator(100)],
      type: 'text',
      placeholder: 'E-mail usado na compra *',
      renderMethod: FIELDS_RENDER_METHOD.PARTIAL_EQUAL,
      isRequired: true,
    },
  ],
};
